export default __webpack_public_path__ + "static/media/spectra-com3.e2bd0025.jpg";